var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$fetchState.pending)?_c('Loading'):_c('ResourceTable',{attrs:{"schema":_vm.$attrs.schema,"rows":_vm.rows,"headers":_vm.$attrs.headers,"group-by":_vm.$attrs.groupBy,"create-able":true}})}
var staticRenderFns = []

export { render, staticRenderFns }